// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"144":"1563bdaa","238":"aa00e32d","453":"2410cd95","455":"dd709178","594":"2354dddd","977":"06dda557"}[chunkId] + ".chunk.js";
};